import { render, staticRenderFns } from "./CambiarContrasenia.vue?vue&type=template&id=72320931&scoped=true&"
import script from "./CambiarContrasenia.vue?vue&type=script&lang=js&"
export * from "./CambiarContrasenia.vue?vue&type=script&lang=js&"
import style0 from "./CambiarContrasenia.vue?vue&type=style&index=0&id=72320931&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72320931",
  null
  
)

export default component.exports